import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./NoticeDetail.scss";
import "../../jodit.css";
function NoticeDetail() {
  let navigate = useNavigate();
  const [detailInfo, setDetailInfo] = useState([]);
  const [createAtInfo, setCreateAtInfo] = useState(""); // 작성일 State 타입을 문자열로 미리 할당(undefined 방지)
  const [addFile, setAddFile] = useState([]);
  const [orderNum, setOrderNum] = useState("");
  const { id } = useParams();
  useEffect(() => {
    axios.get(`/api/board/${id}`).then((response) => {
      setDetailInfo(response.data);
      setCreateAtInfo(response.data.updateAt);
      setAddFile(response.data.docs);
      setOrderNum(response.data.orderNum);
    });
  }, [id]);
  // 공지사항
  // 공고
  // 고시
  const goBoardPage = () => {
    if (detailInfo.typeName === "공지사항") {
      navigate("/notice");
    }
    if (detailInfo.typeName === "공고") {
      navigate("/announcement");
    }
    if (detailInfo.typeName === "고시") {
      navigate("/disclosure");
    }
    if (detailInfo.typeName === "자료실") {
      navigate("/dataroom");
    }
  };
  return (
    <div>
      <div>
        <div className="notice_title_wrap">
          <h1 className="notice_title">
            {detailInfo.title}
            <p className="pubic_info">
              <span>
                <strong>글번호 : {orderNum}</strong>
              </span>
              <span>{createAtInfo?.substring(0, 11).replace(/-/g, ".")}</span>
              <span>{detailInfo.writer}</span>
            </p>
          </h1>
        </div>
        <div className="notice_add_file_area">
          <div className="notice_add_file_wrap">
            <h2>첨부파일</h2>
            <div className="notice_addfile_wrap">
              {addFile.map((docs) => {
                return (
                  <a
                    href={`/api/board/${id}/document/${docs.id}`}
                    key={docs.id}
                    download
                  >
                    {docs.name}
                  </a>
                  // <Link
                  //   to={`/api/board/${id}/document/${docs.id}}`}
                  //   target="_blank"
                  //   key={docs.id}
                  //   download
                  // >
                  //   <span>{docs.name}</span>
                  // </Link>
                );
              })}
            </div>
          </div>
          <div className="notice_content_row">
            <div
              className="jodit-wysiwyg"
              dangerouslySetInnerHTML={{ __html: detailInfo.body }}
            ></div>
            <div style={{ textAlign: "end" }}>
              <button className="btn_color" type="button" onClick={goBoardPage}>
                게시글 닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default NoticeDetail;
